import Tooltip from './tooltip';

const ComparisonTable = ({ plans }) => {
  const sections = [
    {
      name: I18n.t('pricing.caflou-modules'),
      features: [
        {
          name: I18n.t('pricing.caflou-modules-items.relations-with-customers'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.caflou-modules-items.project-management'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.caflou-modules-items.time-organisation'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.caflou-modules-items.financial-health'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t(
            'pricing.caflou-modules-items.billing-documents-contracts'
          ),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.caflou-modules-items.reporting'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.caflou-modules-items.storage'),
          values: [
            '100 MB',
            '25 GB',
            `${I18n.t('from')} 50 GB`,
            `${I18n.t('from')} 500 GB`,
            `${I18n.t('from')} 1 TB`,
          ],
        },
      ],
    },
    {
      name: I18n.t('pricing.work-automation'),
      features: [
        {
          key: 'limits_workflow_causes',
          name: I18n.t(
            'pricing.work-automation-items.process-workflow-automation'
          ),
          hint: I18n.t(
            'pricing.work-automation-items.process-workflow-automation-hint'
          ),
          values: ['limited', 'limited', true, true, true],
        },
        {
          key: 'limits_repeatables',
          name: I18n.t('pricing.work-automation-items.recurring-invoices'),
          values: ['limited', 'limited', true, true, true],
        },
        {
          key: 'limits_repeatables',
          name: I18n.t('pricing.work-automation-items.recurring-projects'),
          values: ['limited', 'limited', true, true, true],
        },
        {
          key: 'limits_repeatables',
          name: I18n.t('pricing.work-automation-items.recurring-tasks'),
          values: ['limited', 'limited', true, true, true],
        },
        {
          key: 'limits_repeatables',
          name: I18n.t('pricing.work-automation-items.recurring-transfers'),
          values: ['limited', 'limited', true, true, true],
        },
        {
          name: I18n.t('pricing.work-automation-items.integration'),
          hint: I18n.t('pricing.work-automation-items.integration-hint'),
          values: [true, true, true, true, true],
        },
        {
          key: 'limits_api_calls',
          name: I18n.t('pricing.work-automation-items.api'),
          hint: I18n.t('pricing.work-automation-items.api-hint'),
          values: ['limited', 'limited', true, true, true],
        },
      ],
    },
    {
      name: I18n.t('pricing.advanced-features'),
      features: [
        {
          name: I18n.t('pricing.advanced-features-items.custom-attributes'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.web-forms'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.email-integration'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.ai'),
          hint: I18n.t('pricing.advanced-features-items.ai-hint'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.private-comments'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.external-sharing'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.trash-management'),
          hint: I18n.t('pricing.advanced-features-items.trash-management-hint'),
          values: [false, false, false, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.superior-security'),
          hint: I18n.t(
            'pricing.advanced-features-items.superior-security-hint'
          ),
          values: [false, false, false, true, true],
        },
        {
          name: I18n.t('pricing.advanced-features-items.private-cloud'),
          values: [false, false, false, false, true],
        },
        {
          name: 'OpenID Connect',
          hint: I18n.t('pricing.advanced-features-items.openid-connect-hint'),
          values: [false, false, false, false, true],
        },
      ],
    },
    {
      name: I18n.t('pricing.settings'),
      features: [
        {
          name: I18n.t('pricing.settings-items.objects'),
          hint: I18n.t('pricing.settings-items.objects-hint'),
          values: [100, 'unlimited', 'unlimited', 'unlimited', 'unlimited'],
        },
        {
          name: I18n.t('pricing.settings-items.roles'),
          hint: I18n.t('pricing.settings-items.roles-hint'),
          values: [false, false, true, true, true],
        },
        {
          name: I18n.t('pricing.settings-items.custom-branding'),
          hint: I18n.t('pricing.settings-items.custom-branding-hint'),
          values: [false, false, false, false, true],
        },
      ],
    },
    {
      name: I18n.t('pricing.users-count'),
      features: [
        {
          name: I18n.t('pricing.users-count-items.maximum-users'),
          values: [1, 1, 100, 100, 'unlimited'],
        },
        {
          key: 'limits_fictive_users',
          name: I18n.t('pricing.users-count-items.fictive-users'),
          values: [false, false, 'limited', 'unlimited', 'unlimited'],
        },
      ],
    },
    {
      name: I18n.t('pricing.support'),
      features: [
        {
          name: I18n.t('pricing.support-items.email'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.support-items.live-chat'),
          values: [true, true, true, true, true],
        },
        {
          name: I18n.t('pricing.support-items.phone'),
          values: [false, false, false, false, true],
        },
        {
          name: I18n.t('pricing.support-items.consultations'),
          hint: I18n.t('pricing.support-items.consultations-hint'),
          values: [false, false, false, '30min', '2h'],
        },
      ],
    },
  ];

  const getValue = ({ value, key, index }) => {
    switch (value) {
      case true:
        return <i className='fa fa-check'></i>;
      case 'limited':
        let hint;
        if (key) {
          let plan = plans[index];
          hint = plan[key];

          if (!hint && plan.user_pricing[plan.user_pricing.length - 1]) {
            hint = plan.user_pricing[plan.user_pricing.length - 1][key];
          }

          if (hint && key == 'limits_fictive_users') {
            hint = (
              <>
                <div>
                  {I18n.t('pricing.fictive-users-count-hint', { count: hint })}
                </div>
                <table className='table-in-hint'>
                  <thead>
                    <tr>
                      <th>
                        {I18n.t('activerecord.models.user', { count: 2 })}
                      </th>
                      <th>
                        {I18n.t('pricing.users-count-items.fictive-users')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {plan.user_pricing.map((userPricing) => (
                      <tr key={userPricing.to || '+'}>
                        <td>{userPricing.to || '+'}</td>
                        <td>{userPricing[key]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            );

            return (
              <Tooltip jsxContent={hint} placement='right'>
                <span>{I18n.t('pricing.limited')}</span>
              </Tooltip>
            );
          }
        }

        if (hint) {
          return (
            <Tooltip content={hint} placement='right'>
              <span>{I18n.t('pricing.limited')}</span>
            </Tooltip>
          );
        } else {
          return I18n.t('pricing.limited');
        }
      case 'unlimited':
        return I18n.t('pricing.unlimited');
      default:
        return value;
    }
  };

  return (
    <>
      <h1>{I18n.t('pricing.plans-comparison')}</h1>
      <div className='pricing-comparison-table-wrapper'>
        <table className='pricing-comparison-table'>
          {sections.map((section) => (
            <React.Fragment key={section.name}>
              <thead>
                <tr>
                  <th>{section.name}</th>
                  {plans.map((plan) => (
                    <th key={plan.id}>{plan[`name_${I18n.locale}`]}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {section.features.map((feature) => (
                  <tr key={feature.name}>
                    <th>
                      <div className='feature-name-wrapper'>
                        <div className='name'>{feature.name}</div>
                        <div className='hint'>
                          {feature.hint && (
                            <Tooltip content={feature.hint} placement='right'>
                              <i className='fal fa-question-circle'></i>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    </th>
                    {feature.values.map((value, index) => (
                      <td key={index}>
                        {getValue({ value, key: feature.key, index })}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </React.Fragment>
          ))}
        </table>
      </div>
    </>
  );
};

export default ComparisonTable;
